import React, { Component } from 'react';
//images
import { connect } from 'react-redux';
import logo from '../../../assets/images/Logo.svg';
import { consoleLog } from '../../../utils';
import { HeaderData_BA, HeaderData_EN, HeaderData_ES } from './ContentLink';

class LeftSection extends Component {

  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.setState({ skipToMainContent: HeaderData_EN.par.static_text_darkTitleBar.SkipToMainContent });
  }

  componentWillReceiveProps(nextProps) {
    switch (nextProps.lang.currentLang.lang) {
      case 'English':
        this.setState({
          skipToMainContent: HeaderData_EN.par.static_text_darkTitleBar.SkipToMainContent
        });
        break;
      case 'Spanish':
        this.setState({
          skipToMainContent: HeaderData_ES.par.static_text_darkTitleBar.SkipToMainContent
        });
        break;
      case 'Bahasa':
        this.setState({
          skipToMainContent: HeaderData_BA.par.static_text_darkTitleBar.SkipToMainContent
        });
        break;
      default:
        this.setState({
          skipToMainContent: HeaderData_EN.par.static_text_darkTitleBar.SkipToMainContent
        });
    }
  }

  handleSkipToMainContent = () => {
    const mainContent = document.querySelector('main'); // Select the DOM content inside the <main> tag

    if (!mainContent) {
      consoleLog('<main> element not found');
      return;
    }

    const firstFocusableElement = mainContent.querySelector(
      'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
    );

    if (firstFocusableElement) {
      consoleLog('First focusable element', 'log', false, firstFocusableElement);
      firstFocusableElement.focus();
    } else {
      consoleLog('No focusable element found inside <main>');
    }
  }

  render() {
    return (
      <div className="gdoc-headerlist gdoc-header-left">
        <div>
          <div className="page-header__logo">
            <img
              className="page-header__brand-logo"
              src={logo}
              alt="HSBC logo"
              title="HSBC logo"
            />
          </div>
          <button class="sr-only sr-only-focusable" onClick={this.handleSkipToMainContent}>
            {this.state.skipToMainContent}
          </button>
        </div>
        <div className="divider"></div>
        <h1 className="tag-line">HSBC Global Documentation Manager</h1>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    lang: state.lang,
  }
}

export default connect(mapStateToProps, null)(LeftSection);


// WEBPACK FOOTER //
// ./src/components/layouts/Header/LeftSection.js